import React from 'react';
import { Box, Avatar } from '@mui/material';

const ProfilePicture = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 4,
        mb: 4,
        position: 'relative',
      }}
    >
      {/* Decorative Circle */}
      <Box
        sx={{
          width: 330,
          height: 330,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #00bfa6, #ff6f61)',
          position: 'absolute',
          zIndex: 1,
          transform: 'scale(1.1)',
        }}
      />
      
      {/* Profile Picture */}
      <Avatar
        src="ProfilePicture.jpg" // Replace with your image path
        alt="Steffen Straub"
        sx={{
          width: 300,
          height: 300,
          zIndex: 2,
          border: '5px solid white', // Adds a border around the image
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
        }}
      />
    </Box>
  );
};

export default ProfilePicture;
